import superagent from 'superagent';
import uuid from 'uuid/v4';

import settingsFile from '../../settings';
import * as defaultConst from '../../src/utils/clientConstant';
import { GetCookie } from '../pages/eventManagement/page/GiftListGuestView/actions';

const methods = ['get', 'post', 'put', 'patch', 'del'];
const settings = process.env.NODE_ENV
  ? settingsFile[process.env.NODE_ENV]
  : settingsFile[env.NODE_ENV]; // eslint-disable-line no-undef

// redundant to server/server.js
let _count = 0;
let port;
if (typeof process !== 'undefined' && process.env.PORT) {
  port = process.env.PORT;
} else if (settings.connection.port) {
  port = settings.connection.port;
} else if (DEVELOPMENT) {
  port = 9000; // TODO: Need to test this logic
} else {
  port = 9051; // TODO: Need to test this logic
}
if (global && global.process) {
  global.process.env.PORT = port;
}

function formatUrl(path) {
  const adjustedPath = path[0] !== '/' ? `/${path}` : path;
  if (SERVER) {
    return `http://${process.env.HOST || 'localhost'}:${port}${adjustedPath}`;
  }
  // Prepend `/api` to relative URL, to proxy to API server.
  return adjustedPath;
}

/* eslint-disable */

const ingnorList = [
  'getNotifications',
  'getMessages',
  'getRegaloRecibidos',
  'getComprasPersonales',
  'typeAhead',
];

export default class ApiClient {
  constructor(req) {
    this.store = null;
    methods.forEach(
      (method) =>
        (this[method] = (path, { params, data } = {}) =>
          new Promise((resolve, reject) => {
            const request = superagent[method](formatUrl(path));

            if (
              typeof window !== 'undefined' &&
              ingnorList.map((p) => path.indexOf(p) > 0).indexOf(true) === -1
            ) {
              if (_count <= 0) {
                _count = 0;
              }
              _count = _count + 1;
              document.getElementById('loading')
                ? (document.getElementById('loading').style.display = 'block')
                : '';
            }
            if (params) {
              request.query(params);
            }

            if (SERVER && req.headers.cookie) {
              request.set('cookie', req.headers.cookie);
            }

            if (SERVER && path === '/api/labels') {
              //check if request object have querystring as showkey
              const _tempQuery = req.query;
              const _tempKey = Object.keys(_tempQuery).filter((p) => {
                if (p.toLowerCase() === defaultConst.showLabelTextQueryString) {
                  return p;
                }
              });
              if (_tempKey.length > 0) {
                const _showLabelText = {};
                _showLabelText[defaultConst.showLabelTextQueryString] =
                  req.query[_tempKey[0]];
                request.query(_showLabelText);
              }
            }

            request.header['x-correlation-id'] = uuid(Date.now());
            if (typeof window !== 'undefined' && document.cookie) {
              const folioId = GetCookie('x-cs-folio-id');
              if (folioId) {
                request.header['x-cs-folio-id'] = folioId;
                const profileId = this.getProfileId();
                if (profileId) {
                  request.header['x-profile-id'] = profileId;
                }
              }
            }
            if (data) {
              request.send(data);
            }
            // cookies creation options
            const _isSecure = false;
            const _option = {
              // ttl: duration,
              isSecure: _isSecure,
              isHttpOnly: true,
              path: '/',
              encoding: 'none',
            };
            const agent = superagent.agent();

            request.end((err, res = {}) => {
              if (err) {
                console.error(
                  'Error occured in API call:',
                  formatUrl(path),
                  err,
                );
                const errorBody = {
                  status: 'failure',
                  errorCode: res?.body?.status || 500,
                  errorMessage:
                    res?.body?.detail || 'An unknown error occurred.',
                };
                reject(errorBody || err);
              } else {
                // Added status in the body

                const responseBody = res.body || {};
                responseBody.status = {
                  status:
                    res.status >= 200 && res.status <= 204
                      ? 'success'
                      : 'failure',
                  errorCode: '',
                  errorMessage: '',
                };
                resolve(responseBody);
              }

              if (
                typeof window !== 'undefined' &&
                path.indexOf('getNotifications') < 0
              ) {
                _count = _count - 1;
                if (_count === 0) {
                  document.getElementById('loading')
                    ? (document.getElementById('loading').style.display =
                        'none')
                    : '';
                  _count = 0;
                }
              }
            });
          })),
    );
  }
  static empty() {}

  setStore(store) {
    this.store = store;
  }

  getProfileId = () => {
    const state = this.store && this.store.getState();
    const profileId =
      (state &&
        state.user &&
        state.user.data &&
        state.user.data.result &&
        state.user.data.result.profileId) ||
      '';
    return profileId;
  };
}
/* eslint-enable */
